import { EventBus } from 'chimera/all/plugins/eventbus'

/**
 * Mixin to track when a user reaches the contact information form step.
 * Add this to any form step that represents the PII entry point.
 *
 * @returns {object}
 */
export default {
  /**
   */
  mounted() {
    EventBus.emitReachedContactFormEvent()
  },
}
